import React from 'react'
import { TopBoxBadge, TopBoxData, TopBoxLeft, TopBoxRight, TopBoxRightData, TopBoxRightDataArea, TopBoxTitle, TopBoxWrapper } from '../styles';
import { useNewUser } from 'CRM/hooks/Dashboard/GetNewUser';
import { useTransActionCount } from 'CRM/hooks/Dashboard/GetTransactionCount';
import { useMoney } from 'CRM/hooks/Dashboard/GetMoney';
import {useIsMobile} from "../../../components/IsMobile";

export const TopBox = () => {
  const { newUser } = useNewUser();
  const { transActionCount } = useTransActionCount();
  const { inputMoney, outputMoney } = useMoney();
  const IsMobile = useIsMobile();

  return (
    <>
      {
        IsMobile ?
          <>
            <TopBoxWrapper IsMobile={IsMobile}>
              <TopBoxLeft IsMobile={IsMobile}>
                <TopBoxTitle IsMobile={IsMobile}>NEW<br/>회원수</TopBoxTitle>
                <TopBoxData IsMobile={IsMobile}>{newUser}</TopBoxData>
              </TopBoxLeft>
              <TopBoxLeft IsMobile={IsMobile}>
                <TopBoxTitle IsMobile={IsMobile}>거래건수</TopBoxTitle>
                <TopBoxData IsMobile={IsMobile}>{transActionCount}</TopBoxData>
              </TopBoxLeft>
            </TopBoxWrapper>
            <TopBoxWrapper IsMobile={IsMobile}>
              <TopBoxRight>
                <TopBoxTitle IsMobile={IsMobile}>총 거래금액</TopBoxTitle>
                <TopBoxRightDataArea IsMobile={IsMobile}>
                  <TopBoxRightData IsMobile={IsMobile}>
                    <TopBoxBadge IsMobile={IsMobile}>입금액</TopBoxBadge>
                    <TopBoxData>{parseFloat(inputMoney)?.toLocaleString()}</TopBoxData>
                  </TopBoxRightData>
                  <TopBoxRightData IsMobile={IsMobile}>
                    <TopBoxBadge IsMobile={IsMobile}>출금액</TopBoxBadge>
                    <TopBoxData >{parseFloat(outputMoney)?.toLocaleString()}</TopBoxData>
                  </TopBoxRightData>
                </TopBoxRightDataArea>
              </TopBoxRight>
            </TopBoxWrapper>
          </>

          :
          <TopBoxWrapper>
            <TopBoxLeft>
              <TopBoxTitle>NEW<br/>회원수</TopBoxTitle>
              <TopBoxData>{newUser}</TopBoxData>
            </TopBoxLeft>
            <TopBoxLeft>
              <TopBoxTitle>거래건수</TopBoxTitle>
              <TopBoxData>{transActionCount}</TopBoxData>
            </TopBoxLeft>
            <TopBoxRight>
              <TopBoxTitle>총 거래금액</TopBoxTitle>
              <TopBoxRightDataArea>
                <TopBoxRightData>
                  <TopBoxBadge>입금액</TopBoxBadge>
                  <TopBoxData>{parseFloat(inputMoney)?.toLocaleString()}</TopBoxData>
                </TopBoxRightData>
                <TopBoxRightData>
                  <TopBoxBadge>출금액</TopBoxBadge>
                  <TopBoxData>{parseFloat(outputMoney)?.toLocaleString()}</TopBoxData>
                </TopBoxRightData>
              </TopBoxRightDataArea>
            </TopBoxRight>
          </TopBoxWrapper>
      }
    </>
  )
}

export default React.memo(TopBox);